import { isPositiveNumber } from "../../../../helpers";

export function validateIntakeGroup(intakes, groupName, errors) {
  (intakes || []).forEach((intake, index) => {
    if (intake && intake.deadline && !intake.deadline.isValid()) {
      errors[groupName][index] = { deadline: " " };
    }

    if (intake && intake.startDate && !intake.startDate.isValid()) {
      if (errors[groupName][index]) {
        errors[groupName][index].startDate = " ";
      } else {
        errors[groupName][index] = { startDate: " " };
      }
    }

    if (
      intake?.deadline &&
      intake?.startDate &&
      intake.startDate
        .clone()
        .startOf("day")
        .isBefore(intake.deadline.clone().startOf("day").add(3, "day"))
    ) {
      errors[groupName][index] = {
        deadline: " ",
        startDate: " ",
      };
    }

    if (!intake?.startDate) {
      errors[groupName][index] = {
        ...(errors[groupName][index] || {}),
        startDate: "Start Date is required",
      };
    }

    if (!intake?.deadline) {
      errors[groupName][index] = {
        ...(errors[groupName][index] || {}),
        deadline: "Deadline is required",
      };
    }
  });
}

export function validateExamsGroup(exams, groupName, errors) {
  (exams || []).forEach((exam, index) => {
    if (exam && exam.name?.trim() && !exam.score?.trim()) {
      errors[groupName][index] = { score: "Score is required" };
    }

    if (exam && exam.score?.trim() && !exam?.name?.trim()) {
      if (errors[groupName][index]) {
        errors[groupName][index].name = "Exam is required";
      } else {
        errors[groupName][index] = { name: "Exam is required" };
      }
    }

    if (exam && exam.score?.trim() && exam.score.trim().length > 20) {
      if (errors[groupName][index]) {
        errors[groupName][index].score = "Max 20 characters allowed";
      } else {
        errors[groupName][index] = { score: "Max 20 characters allowed" };
      }
    }
  });
}

export function validateOtherFeesGroup(otherFees, groupName, errors) {
  (otherFees || []).forEach((otherFee, index) => {
    if (otherFee?.name?.trim()) {
      if (!otherFee.amount?.trim()) {
        errors[groupName][index] = { amount: "Amount is required" };
      } else if (!isPositiveNumber(otherFee.amount)) {
        errors[groupName][index] = { amount: "Amount is invalid" };
      } else if (otherFee.amount.trim().split(".")[1]?.length > 2) {
        errors[groupName][index] = {
          amount: "Max 2 digits allowed after decimal point",
        };
      }
    }

    if (otherFee?.amount?.trim()) {
      if (!otherFee.name?.trim()) {
        if (errors[groupName][index]) {
          errors[groupName][index].name = "Name is required";
        } else {
          errors[groupName][index] = { name: "Name is required" };
        }
      }
    }
  });
}

export function validateAmountAndType(
  amount,
  amountName,
  type,
  typeName,
  errors,
) {
  if (amount?.trim()) {
    if (!isPositiveNumber(amount)) {
      errors[amountName] = "Amount is not valid";
    } else if (amount.trim().split(".")[1]?.length > 2) {
      errors[amountName] = "Max 2 digits allowed after decimal point";
    }

    if (!type) {
      errors[typeName] = "Type is required";
    }
  }

  if (type) {
    if (!amount?.trim()) {
      errors[amountName] = "Amount is required";
    } else if (type?.name === "Percent" && +amount > 100) {
      errors[amountName] = "Enter less than 100";
    }
  }
}
